module.exports = __webpack_public_path__ + "static/stardust-image-avatar-28e06a90ead4efa86e59bb7eb80058fd.png";